import { GetTokenSilentlyOptions } from '@auth0/auth0-react'

type GetAccessTokenSilentlyHandler = (
  options?: GetTokenSilentlyOptions | undefined,
) => Promise<string>

let getAccessTokenSilentlyHandler: null | GetAccessTokenSilentlyHandler = null

// Hack to enable calling getAccessTokenSilently from outside of a React component,
// as we do in RTKQuery's createApi prepareHeaders function
// https://github.com/reduxjs/redux-toolkit/issues/1331#issuecomment-1080901326
export const sec = {
  getAccessTokenSilently: () => getAccessTokenSilentlyHandler?.(),
  setAccessTokenSilentlyHandler: (func: GetAccessTokenSilentlyHandler) => {
    getAccessTokenSilentlyHandler = func
  },
}
